import axios from '../../axiosInstance';

const baseUrlApi = '/master/billing';
const baseUrlApimaster = '/master';

class BillingService {

    getChargeType() {
        return axios.get(baseUrlApi + '/getChargeType');
    }
    insertChargeType(details) {
        return axios.post(baseUrlApi + '/insertChargeType', details);
    }
    updateChargeType(details) {
        return axios.put(baseUrlApi + '/updateChargeType', details);
    }
    deleteChargeType(chargeTypeName) {
        return axios.delete(baseUrlApi + '/deleteChargeType?chargeTypeName=' + chargeTypeName);
    }

    //bill
    getCharge() {
        return axios.get(baseUrlApi + '/getCharge');
    }
    insertCharge(details) {
        return axios.post(baseUrlApi + '/insertCharge', details);
    }
    updateCharge(details) {
        return axios.put(baseUrlApi + '/updateCharge', details);
    }
    deleteCharge(chargeName) {
        return axios.delete(baseUrlApi + '/deleteCharge?chargeName=' + chargeName);
    }

    //Quatetion
    getQuotationType() {
        return axios.get(baseUrlApimaster + '/getQuotationType');
    }
    getItem() {
        return axios.get(baseUrlApi + '/getItem');
    }
    getCustomerType(flag) {
        return axios.get(baseUrlApi + '/getCustomerType?flag=' + flag);
    }
    getCustomerBasedCustomerType(customerType) {
        return axios.get(baseUrlApimaster + '/getCustomerBasedCustomerType?customerType=' + customerType);
    }
    getCustomLocation() {
        return axios.get(baseUrlApi + '/getCustomLocation');
    }
    getUOM() {
        return axios.get(baseUrlApi + '/getUOM');
    }
    getImporter(details) {
        return axios.post(baseUrlApi + '/getImporter', details);
    }
    getForwarder(details) {
        return axios.post(baseUrlApi + '/getForwarder', details);
    }
    getCustomHouseCode(details) {
        return axios.post(baseUrlApi + '/getCustomHouseCode', details);
    }
    getUOMSearch(details) {
        return axios.post(baseUrlApi + '/getUOMSearch', details);
    }
    getCustomTariff(details) {
        return axios.post(baseUrlApi + '/getCustomTariff', details);
    }
    getCustomTariffALL() {
        let details = { importerIecNo: '-1', clearanceLocationCode: '-1', unitCode: '-1' }
        return axios.post(baseUrlApi + '/getCustomTariff', details);
    }
    getCustomTariffFreightForwarder(details) {
        return axios.post(baseUrlApi + '/getCustomTariffFreightForwarder', details);
    }
    getCustomTariffFreightForwarderAll() {
        let details = { importerIecNo: '-1', clearanceLocationCode: '-1', unitCode: '-1' }
        return axios.post(baseUrlApi + '/getCustomTariffFreightForwarder', details);
    }
    insertCustomTariff(details) {
        return axios.post(baseUrlApi + '/insertCustomTariff', details)
    }
    updateCustomTariff(details) {
        return axios.put(baseUrlApi + '/updateCustomTariff', details)
    }
    updateCustomTariffVerifiedStatus(details) {
        return axios.put(baseUrlApi + '/updateCustomTariffVerifiedStatus', details)
    }
    deleteCustomTariff(customTariffID) {
        return axios.delete(baseUrlApi + '/deleteCustomTariff?customTariffID=' + customTariffID)
    }
    insertCustomTariffFreightForwarder(details) {
        return axios.post(baseUrlApi + '/insertCustomTariffFreightForwarder', details)
    }
    updateCustomTariffFreightForwarder(details) {
        return axios.put(baseUrlApi + '/updateCustomTariffFreightForwarder', details)
    }
    deleteCustomTariffFreightForwarder(customTariffID) {
        return axios.delete(baseUrlApi + '/deleteCustomTariffFreightForwarder?customTariffID=' + customTariffID)
    }


    //UOM

    insertUOM(details) {
        return axios.post(baseUrlApi + '/insertUOM', details);
    }
    updateUOM(details) {
        return axios.put(baseUrlApi + '/updateUOM', details);
    }
    deleteUOM(unitCode) {
        return axios.delete(baseUrlApi + '/deleteUOM?unitCode=' + unitCode);
    }

    //itemtype

    insertItem(details) {
        return axios.post(baseUrlApi + '/insertItem', details);
    }
    updateItem(details) {
        return axios.put(baseUrlApi + '/updateItem', details);
    }
    deleteItem(itemID) {
        return axios.delete(baseUrlApi + '/deleteItem?itemID=' + itemID)
    }



}

export default new BillingService();
